module.exports = "/static/media/fax-papers.659df12b.svg";